import { render, staticRenderFns } from "./EmailVerified.vue?vue&type=template&id=285413cd&scoped=true"
import script from "./EmailVerified.vue?vue&type=script&lang=ts"
export * from "./EmailVerified.vue?vue&type=script&lang=ts"
import style0 from "./EmailVerified.vue?vue&type=style&index=0&id=285413cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285413cd",
  null
  
)

export default component.exports